import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  getters: {
    uploadUrl: (state) => {
      return `${config.serverURI}/activityNonGens/upload`
    }
  },
  actions: {
  	loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/activityNonGens`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/activityNonGens/page`, { params: pagination })
    },
    fetchItem ({ commit, dispatch }, payload) {
      console.log('-> fetchItem')
      return Vue.axios.get(`${config.serverURI}/activityNonGens/${payload}`)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/activityNonGens`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/activityNonGens/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('delete', payload)
      return Vue.axios.delete(`${config.serverURI}/activityNonGens/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/activityNonGen.js